const dataTeachers = [

    {
        id:1,
        image: `https://img.freepik.com/free-photo/woman-with-yoga-mat_1303-13969.jpg?size=626&ext=jpg&uid=R84336364&ga=GA1.1.252329103.1673513594&semt=ais`,
        name: 'Marika',
        yoga: 'Vinayasa',
        line: 'Yoga is not about touching your toes, it’s about what you learn on the way down.'

    },

    {
        id:2,
        image: `https://img.freepik.com/premium-photo/slim-young-woman-practices-yoga-exercises-home_163305-9424.jpg?size=626&ext=jpg&uid=R84336364&ga=GA1.1.252329103.1673513594&semt=ais`,
        name: 'Poline',
        yoga: 'Hatha',
        line: 'True yoga is not about the shape of your body, but the shape of your life. '

    }
,
    {
        id:3,
        image: `https://img.freepik.com/free-photo/beautiful-girl-is-engaged-yoga-studio_1157-29599.jpg?size=626&ext=jpg&uid=R84336364&ga=GA1.1.252329103.1673513594&semt=ais`,
        name: 'Elsa',
        yoga: 'Ashtanga',
        line: 'Yoga is the ultimate practice. It simultaneously stimulates our inner light and quiets our overactive minds.'

    }
,
{
    id:4,
    image: `https://img.freepik.com/free-photo/woman-doing-yoga-exercises-beach_1098-1449.jpg?size=626&ext=jpg&uid=R84336364&ga=GA1.1.252329103.1673513594&semt=ais`,
    name: 'Olivia',
    yoga: 'Kundalini, Reiki, SoundHealing',
    line: 'Yoga means addition – addition of energy, strength and beauty to body, mind and soul.'

}

]

export default dataTeachers;